import { apiClient } from '../axios.config';
import { API_ENDPOINTS } from '../constants';
import type { ApiResponse } from '../types/common';
import type {
  PaymentApiStatus,
  PaymentCurrencies,
  PaymentMinAmount,
  PaymentEstimate,
  CreatePaymentRequest,
  CreatePaymentResponse,
  PaymentStatus,
} from '../types/payment.types';

export const paymentService = {
  getStatus: async (): Promise<ApiResponse<PaymentApiStatus>> => {
    const { data } = await apiClient.get<ApiResponse<PaymentApiStatus>>(
      API_ENDPOINTS.PAYMENT.STATUS
    );
    return data;
  },

  getCurrencies: async (): Promise<ApiResponse<PaymentCurrencies>> => {
    const { data } = await apiClient.get<ApiResponse<PaymentCurrencies>>(
      API_ENDPOINTS.PAYMENT.CURRENCIES
    );
    return data;
  },

  getMinAmount: async (
    currencyFrom: string,
    currencyTo: string
  ): Promise<ApiResponse<PaymentMinAmount>> => {
    const { data } = await apiClient.get<ApiResponse<PaymentMinAmount>>(
      API_ENDPOINTS.PAYMENT.MIN_AMOUNT,
      { params: { currency_from: currencyFrom, currency_to: currencyTo } }
    );
    return data;
  },

  getEstimate: async (
    amount: number,
    currencyFrom: string,
    currencyTo: string
  ): Promise<ApiResponse<PaymentEstimate>> => {
    const { data } = await apiClient.get<ApiResponse<PaymentEstimate>>(
      API_ENDPOINTS.PAYMENT.ESTIMATE,
      { params: { amount, currency_from: currencyFrom, currency_to: currencyTo } }
    );
    return data;
  },

  createPayment: async (
    params: CreatePaymentRequest
  ): Promise<ApiResponse<CreatePaymentResponse>> => {
    const { data } = await apiClient.post<ApiResponse<CreatePaymentResponse>>(
      API_ENDPOINTS.PAYMENT.CREATE,
      params
    );
    return data;
  },

  getPaymentStatus: async (
    paymentId: number
  ): Promise<ApiResponse<PaymentStatus>> => {
    const { data } = await apiClient.get<ApiResponse<PaymentStatus>>(
      API_ENDPOINTS.PAYMENT.PAYMENT_STATUS(String(paymentId))
    );
    return data;
  },
};
